<template>
  <div v-if="visible" class="lightbox-overlay" @click.self="close">
    <button class="lightbox-close" @click="close">&times;</button>
    <button v-if="hasPrev" class="lightbox-nav lightbox-prev" @click="prev">&lsaquo;</button>
    <button v-if="hasNext" class="lightbox-nav lightbox-next" @click="next">&rsaquo;</button>
    <div class="lightbox-content">
      <img :src="currentImage.url" :alt="currentImage.name" @load="imageLoaded = true" />
      <div v-if="currentImage.name" class="lightbox-caption">
        {{ currentImage.name }}
        <span v-if="images.length > 1" class="lightbox-counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatImageLightbox',
  props: {
    visible: { type: Boolean, default: false },
    images: { type: Array, default: () => [] },
    startIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      currentIndex: this.startIndex,
      imageLoaded: false
    }
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex] || {}
    },
    hasPrev() {
      return this.currentIndex > 0
    },
    hasNext() {
      return this.currentIndex < this.images.length - 1
    }
  },
  watch: {
    startIndex(val) {
      this.currentIndex = val
    },
    visible(val) {
      if (val) {
        this.currentIndex = this.startIndex
        document.addEventListener('keydown', this.handleKeydown)
      } else {
        document.removeEventListener('keydown', this.handleKeydown)
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    close() {
      this.$emit('close')
    },
    prev() {
      if (this.hasPrev) {
        this.imageLoaded = false
        this.currentIndex--
      }
    },
    next() {
      if (this.hasNext) {
        this.imageLoaded = false
        this.currentIndex++
      }
    },
    handleKeydown(e) {
      if (e.key === 'Escape') this.close()
      if (e.key === 'ArrowLeft') this.prev()
      if (e.key === 'ArrowRight') this.next()
    }
  }
}
</script>

<style scoped>
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  color: #fff;
  font-size: 36px;
  cursor: pointer;
  z-index: 100000;
  padding: 5px 10px;
  line-height: 1;
}

.lightbox-close:hover {
  color: #ccc;
}

.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  font-size: 48px;
  cursor: pointer;
  padding: 10px 18px;
  z-index: 100000;
  border-radius: 4px;
  line-height: 1;
}

.lightbox-nav:hover {
  background: rgba(255, 255, 255, 0.25);
}

.lightbox-prev {
  left: 15px;
}

.lightbox-next {
  right: 15px;
}

.lightbox-content {
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.lightbox-content img {
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 4px;
}

.lightbox-caption {
  color: #ccc;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.lightbox-counter {
  margin-left: 10px;
  color: #888;
}
</style>
